import { MathUtils } from "../../utils";

export function mappingSitecoreToLocalHeroIntro(params) {
  return {
    fields: {
      paddingAboveBottom: { fields: { key: { value: "default" } } },
      paddingAboveTop: { fields: { key: { value: "default" } } },
      logo: { value: "$.data.brand.fields[?(@.name=== 'logo')]" },
      headingBody: {
        value: `<span class="type-h1">${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "heroIntroHeading")?.value}</span>`
      },
      headingType: {
        fields: { key: { value: "h1" }, phrase: { value: "h1" } }
      },
      videoAutoPlay: { value: false },
      sound: { value: false },
      image: {
        value: {
          src: "$.data.brand.fields[?(@.name === 'heroIntroImage')].src",
          alt: "$.data.brand.fields[?(@.name === 'heroIntroImage')].alt",
          title: "$.data.brand.fields[?(@.name === 'heroIntroImage')].title"
        }
      }
    }
  };
}

export function mappingSitecoreToIconContentRight(params) {
  return {
    fields: {
      paddingAboveBottom: { fields: { phrase: { value: "none" } } },
      paddingAboveTop: { fields: { phrase: { value: "small" } } },
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: `<span class="type-h3">${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "iconContentOneHeading")?.value}</span>`
      },
      headingType: {
        fields: { key: { value: "h3" }, phrase: { value: "h3" } }
      },
      body: {
        value: `<span>${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "iconContentOneBody")?.value}</span>`
      },
      gridType: { fields: { phrase: { value: "normal" } } },
      order: { fields: { phrase: { value: "normal" } } },
      equalColumns: { value: "true" },
      image: {
        value: {
          src: "$.data.brand.fields[?(@.name === 'iconContetnOneImage')].src",
          alt: "$.data.brand.fields[?(@.name === 'iconContetnOneImage')].alt",
          title: "$.data.brand.fields[?(@.name === 'iconContetnOneImage')].title"
        }
      },
      backgroundImage: { value: {} },
      icons: { value: {} }
    },
    rendering: { dataSource: {} }
  };
}

export function mappingSitecoreToIconContentLeft(params) {
  return {
    fields: {
      paddingAboveBottom: { fields: { phrase: { value: "none" } } },
      paddingAboveTop: { fields: { phrase: { value: "small" } } },
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: `<span class="type-h3">${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "iconContentTwoHeading")?.value}</span>`
      },
      headingType: {
        fields: { key: { value: "h3" }, phrase: { value: "h3" } }
      },
      body: {
        value: `<span>${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "iconContentTwoBody")?.value}</span>`
      },
      gridType: { fields: { phrase: { value: "normal" } } },
      order: { fields: { phrase: { value: "reverse" } } },
      equalColumns: { value: "true" },
      image: {
        value: {
          src: "$.data.brand.fields[?(@.name === 'iconContentTwoImage')].src",
          alt: "$.data.brand.fields[?(@.name === 'iconContentTwoImage')].alt",
          title: "$.data.brand.fields[?(@.name === 'iconContentTwoImage')].title"
        }
      },
      backgroundImage: { value: {} },
      icons: { value: {} }
    },
    rendering: { dataSource: {} }
  };
}

export function mappingSitecoreToTextContent(params) {
  return {
    fields: {
      paddingAboveBottom: { fields: { phrase: { value: "none" } } },
      paddingAboveTop: { fields: { phrase: { value: "small" } } },
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: `<span class="type-h3">${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "textContentHeading")?.value}</span>`
      },
      headingType: {
        fields: { key: { value: "h3" }, phrase: { value: "h3" } }
      },
      body: {
        value: `<span>${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "textContentBody")?.value}</span>`
      },
      gridType: { fields: { phrase: { value: "normal" } } },
      alignment: { fields: { phrase: { value: "left" } } }
    },
    rendering: { dataSource: {} }
  };
}

export function mappingOtherGearToTextContent(params) {
  return {
    fields: {
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: `<span>${params.productName}</span>`
      },
      body: {
        value: `<span class="type-h4">${MathUtils.priceFormat(params.minPrice, params.lang)}</span>`
      },
      image: {
        value: {
          type: "image",
          src: params.images[0],
          alt: "",
          title: ""
        }
      },
      CTA: [
        {
          fields: {
            ctatype: {
              fields: {
                key: { value: "primary-link" },
                phrase: { value: "primary-link" }
              }
            },
            colorScheme: {
              fields: {
                phrase: { value: "green" },
                key: { value: "green" }
              }
            },
            link: {
              value: {
                anchor: "",
                class: "",
                href: "",
                linktype: "internal",
                querystring: "",
                target: "",
                text: "",
                title: ""
              }
            },
            iconName: {
              value: {
                alt: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"> <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>'
              }
            }
          }
        }
      ]
    }
  };
}

export function mappingOtheHeroesToTextContent(item) {
  return {
    fields: {
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: `<span>${item.fields.find(x => x.name === "name")?.value}</span>`
      },
      numberOfItemsInRowMobile: { value: 3 },
      body: {
        value: `<span class="type-h5">${item.fields.find(x => x.name === "previewDescription")?.value}</span>`
      },
      image: {
        value: {
          type: "image",
          src: item.fields.find(x => x.name === "previewImage")?.src,
          alt: "",
          title: ""
        }
      },
      CTA: [
        {
          fields: {
            ctatype: {
              fields: {
                key: { value: "primary-link" },
                phrase: { value: "primary-link" }
              }
            },
            colorScheme: {
              fields: {
                phrase: { value: "green" },
                key: { value: "green" }
              }
            },
            link: {
              value: {
                anchor: "",
                class: "",
                href: "",
                linktype: "internal",
                querystring: "",
                target: "",
                text: "",
                title: ""
              }
            },
            iconName: {
              value: {
                alt: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"> <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>'
              }
            }
          }
        }
      ]
    }
  };
}
